export default "__VITE_ASSET__f0adb876__"